<template>
    <div class="multi-device-body">
        <div class="multi-device-title">
            マルチデバイスに対応 
        </div>
        <div class="multi-device-msg">
            iPhone、iPad、Androidスマホや、fireTV Stick、<br/>
            Google play対応のSmartTV BOXなど、モバイル端末<br/>
            からスマートTVまで、マルチデバイスに対応しています。
        </div>
        <div class="main-image">
            <img :src="main" />
        </div>
        <div class="btn-area">
            <div class="btn-outer" v-for='(n, index) in toolsList' :key="index">
                <div class="btn" @click="selectedIndex = index" :class="{selected: selectedIndex === index}">
                    <img :src="selectedIndex === index ? n.iconSelected : n.icon" />
                    <div class="tools-name">
                        {{ n.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { toolsList, main } from '../../../images/multi-device'
export default {
    data () {
        return {
            toolsList,
            main,
            selectedIndex: null
        }
    },
    methods: {

    }
}
</script>
<style scoped>
.multi-device-body {
    background: #F3F3F3;
    text-align: center;
    padding-top: 60px;
    padding-bottom: 10px;
}
.multi-device-title {
    font-size: 26px;
    font-family: A-OTF Gothic MB101 Pr5;
    font-weight: normal;
    color: #000000;
    margin-bottom: 20px;
    font-weight: bold;
}
.multi-device-msg {
    font-size: 14px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #000000;
    margin-bottom: 30px;
}
.main-image img {
    height: 150px;
    display: block;
    margin: 0 auto;
}
.btn-area {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    text-align: center;
}
.btn-outer {
    width: 33%;
    box-sizing: border-box;
    padding: 5px;
    display: inline-block;
    vertical-align: top;
    margin-bottom: 5px;

}
.btn {
    width: 100%;
    border-radius: 10px;
    background: #fff;
    height: auto;
    min-height: 130px;
    box-sizing: border-box;
    padding-top: 10px;
    transition: all .2s;
}
.btn img {
    display: block;
    height: 70px;
    margin: 0 auto;
    margin-bottom: 10px;
}
.tools-name {
    font-size: 12px;
    transform: scale(0.9);
}
.btn.selected {
    background: #FDB819;
    color: #fff;
}
</style>